import React from "react";

import { SelectList } from "@common/selectList";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Resource } from "./resource";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourcesPicker({
  title,
  resources,
  addResources,
  removeResources,
}: Props) {
  return (
    <div className={styles.resourcesPicker}>
      <h3 className={styles.title}>{title}</h3>
      <SelectList listClassName={styles.list} multiple>
        {() => ({
          input: <AddAllocationIcon className={styles.addIcon} />,
          list: (
            <ResourceAllocationMenu
              allocatedResources={resources}
              select={addResources}
              unSelect={removeResources}
              openedViews={["resources"]}
            />
          ),
        })}
      </SelectList>
      <div className={styles.resources}>
        {resources.map((resource) => (
          <div key={resource.uuid} className={styles.resource}>
            <Resource
              resource={resource}
              remove={(removed) => removeResources([removed])}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export { ResourcesPicker };
